import { API_HEADER } from "../../util/constants/HEADERS"
import { SendEmail } from "../sendEmail"


export async function getUserByEmail (user: { email: any }) {
    return await fetch(`${process.env.REACT_APP_API_URL}user/getUserByEmail/${user.email}`, {
        method: 'GET',
        headers: API_HEADER
    })
    .then((response) => response.json())
    .then(async (result) => {
        if (result.status) {
            const { data } = result
            if (data?.id) {
                await SendEmail(data)
                return {
                    status: true,
                    message: 'Se ha enviado las credenciales a su correo.'
                }
            }
        }
    })
    .catch(err => {
        const { error } = err
        return {
            status: false,
            message: error.message
        }
    })
}

export async function saveInstructor (user: { instructor?: any; id: any }) {
    return await fetch(`${process.env.REACT_APP_API_URL}user/update/${user.id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json, text/plain, */*',
        },
        body: JSON.stringify(user)
    })
    .then((response) => response.json())
    .then(async (result) => {
        if (result.status) {
            const { data } = result
            return {
                status: true,
                message: data
            }
        }
    })
    .catch(err => {
        const { error } = err
        return {
            status: false,
            message: error.message
        }
    })
}